import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

// Helper functions for styles and icons
const getBackgroundStyle = (icon) => {
    const gradients = {
        success: "linear-gradient(0deg, rgba(2,0,36,1) 0%, rgba(31,121,9,0.28) 0%, rgba(255,255,255,1) 100%)",
        error: "linear-gradient(0deg, rgba(2,0,36,1) 0%, rgba(255,0,0,0.23) 0%, rgba(255,255,255,0) 100%)",
        info: "linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,193,7,0.28) 0%, rgba(255,255,255,0) 100%)",
    };
    return icon ? { background: gradients[icon] } : {};
};

const getIconComponent = (icon) => {
    const styles = {
        fontSize: 120,
    };
    switch (icon) {
        case "success":
            return <CheckCircleOutlineIcon style={{ ...styles, color: "green" }} />;
        case "error":
            return <CancelOutlinedIcon style={{ ...styles, color: "red" }} />;
        case "info":
            return <ErrorOutlineIcon style={{ ...styles, color: "#ffc107" }} />;
        default:
            return null;
    }
};

const getTitleStyle = (icon) => {
    const colors = {
        success: "green",
        error: "red",
        info: "#ffc107",
    };
    return {
        fontSize: 30,
        color: colors[icon] || "#000",
    };
};

function AlertDialogue({ open = false, icon = "", title = "", description = "", buttons = <></> }) {
    return (
        <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
        >
            <DialogContent style={getBackgroundStyle(icon)}>
                <div
                    className="text-center my-3"
                    style={{ color: "#4d4d4d" }}
                >
                    <div>{getIconComponent(icon)}</div>
                    <div style={{ margin: "30px 0" }}>
                        <p style={getTitleStyle(icon)}>{title}</p>
                        <p style={{ fontSize: 20 }}>{description}</p>
                    </div>
                </div>
            </DialogContent>
            <DialogActions style={{ display: "flex", justifyContent: "center" }}>{buttons}</DialogActions>
        </Dialog>
    );
}

AlertDialogue.propTypes = {
    open: PropTypes.bool,
    icon: PropTypes.oneOf(["success", "error", "info", ""]), // better validation
    title: PropTypes.string,
    description: PropTypes.string,
    buttons: PropTypes.element,
};

export default AlertDialogue;
